<template>
  <div class="member">
    <el-dialog
      v-model="isEdit"
      width="1000px"
      @close="close"
      :title="$t('profile.memberProfile')"
    >
      <el-tabs
        :tab-position="tabPosition"
        style="height: 700px"
        class="member-tabs"
        v-model="activeName"
      >
        <el-tab-pane :label="$t('profile.basicInfo')" name="basic">
          <Basic
            v-if="userInfoList.email"
            :userInfoList="userInfoList"
            :userName="userInfoList.userName"
            @uploadSuccess="uploadSuccess"
          />
        </el-tab-pane>
        <el-tab-pane :label="$t('profile.professInfo')" name="Profession">
          <Profession v-if="userInfoList.email" :userInfoList="userInfoList" />
        </el-tab-pane>
      </el-tabs>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="primary" @click="save">{{
            $t('profile.save')
          }}</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import Basic from './basic.vue'
import Profession from './profession.vue'
import { updateUserInfo } from '@/api/profile'
import { UserInfo } from '@/api/type'
import { ElMessage } from 'element-plus'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  props: {
    isEdit: {
      type: Boolean,
      required: true,
    },
    userInfoList: {
      type: Object,
      default: () => ({}),
    },
  },
  components: { Basic, Profession },
  setup(props, { emit }) {
    const { t } = useI18n()
    const outerVisible = ref<boolean>(true)
    const innerVisible = ref<boolean>(false)
    const tabPosition = ref<string>('left')
    const activeName = ref<string>('basic')

    const close = () => {
      emit('close')
    }
    const save = async () => {
      const res = await updateUserInfo(props.userInfoList as UserInfo)
      if (res.status === 200) {
        ElMessage({
          message: t('profile.updateSuccess'),
          type: 'success',
        })
        emit('updateSucess')
      }
    }
    const uploadSuccess = () => {
      emit('uploadSuccess')
    }

    return {
      outerVisible,
      innerVisible,
      close,
      save,
      tabPosition,
      activeName,
      uploadSuccess,
    }
  },
})
</script>
<style lang="less" scoped>
.member {
  .member-tabs {
    /deep/.is-active {
      color: #303133;
      background: #f7f8f8;
    }
  }

  /deep/.el-tabs__item {
    font-size: 20px;
    height: 68px;
    line-height: 68px;
    color: rgba(48, 49, 51, 0.5);
  }
  /deep/.el-tabs__header {
    width: 225px;
  }
  /deep/.el-dialog__body {
    padding-left: 0px;
    padding-top: 0px;
  }
  /deep/.el-dialog__header {
    height: 85px;
    line-height: 50px;
    font-size: 24px;
    border-bottom: 1px solid #e5e5e5;
    .el-dialog__title {
      font-size: 24px;
    }
  }
  /deep/.el-tabs__nav-wrap::after {
    width: 0px;
    border-right: 1px solid #dcdfe6;
  }
  /deep/.el-dialog .el-dialog__footer {
    border-top: 1px solid #dcdfe6;
    text-align: center;
    .el-button {
      width: 300px;
      height: 50px;
      background: #0ca1bd;
      margin-top: 15px;
      margin-bottom: 5px;
    }
  }
  /deep/ .el-checkbox__label {
    height: 25px;
    line-height: 25px;
    font-family: Georgia;
    color: #6b727f !important;
    font-size: 12px;
  }
  /deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
  /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #0ca1bd;
    border-color: #0ca1bd;
  }
  /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #0ca1bd;
  }
  /deep/.el-checkbox.is-bordered.is-checked {
    border-color: #0ca1bd;
  }
  /deep/ .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #0ca1bd;
  }
}
</style>
